import userService from 'api/user'

import * as mutationTypes from 'store/mutationTypes'

/**
 * @return {Promise}
 */
export const getCurrentUser = function ({ commit }) {
  return userService.me().then((result) => {
    commit(mutationTypes.SET_CURRENT_USER, result)

    return result
  })
}

/**
 * @return {Promise}
 */
export const removeCurrentUser = function ({ commit }) {
  return commit(mutationTypes.SET_CURRENT_USER, null)
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js